var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-callai"},[_c('callai-top'),_c('callai-team'),_c('team-process'),_c('team-honer'),_c('contact-us')],1)}
var staticRenderFns = []

export { render, staticRenderFns }